import {Component, Input} from '@angular/core';
import {SynapiItem} from "../../../models/Synapi/SynapiItem";
import {NewsletterData} from "../../../models/Misc/NewsletterData";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {NgIf} from "@angular/common";

@Component({
  selector: 'newsletter-modal',
  standalone: true,
  imports: [
    SafeHtmlPipe,
    NgIf
  ],
  templateUrl: './newsletter-modal.component.html',
  styleUrl: './newsletter-modal.component.scss'
})
export class NewsletterModalComponent {
  @Input() data : NewsletterData;
}
